/**
 * 统一验证码文档
 * https://confluence.sf-express.com/pages/viewpage.action?pageId=308677362
 */

// import { getEnvObj } from './env'
import store from '@/store/index'
// import vue from '@/main'
// import { TencentQRCode } from '@ibu/jslib'
// import { SfCaptchaValid, removeSfCaptcha } from '@/utils/SfCaptcha'
import { $track } from '@/utils/reporter/index'
// import { ICaptcha } from '@ibu/icaptcha'
import { isOS } from '@/utils/constant'
import { reportScriptLoadError } from '@ibu/icaptcha-report-util'
let script
export const CAPTCHA_JS_URL = async() => {
  return new Promise((resolve, reject) => {
    let env = ''
    // 生产环境 测试环境
    if (window._global.ENV === 'PRD') {
      if (window._global.CURRENT_SITE === 'CN') {
        env = 'prd-sfyun'
      } else if (window._global.CURRENT_SITE !== 'CN') {
        env = 'prd-gcp'
      }
    } else {
      // 测试环境
      if (window._global.CURRENT_SITE === 'CN') {
        if (window.location.host.indexOf('ibu-icas-w.sit.sf-express.com') !== -1) {
          env = 'sit'
        } else {
          env = 'sit'
        }
      } else if (window._global.CURRENT_SITE !== 'CN') {
        env = 'gcp' // sg测试环境
      }
    }

    const option = {
      'sysCode': isOS() ? 'IBU-ICAS-CORE-OS' : 'IBU-ICAS-CORE',
      'env': env,
    }

    let jsUrl = './index.umd.js'
    if (window._global && window._global.CAPTCHA_JS_URL) {
      jsUrl = window._global.SITE[window._global.CURRENT_SITE] + '/index.umd.js'
    }
    script = document.createElement('script')
    script.addEventListener('load', resolve)
    script.src = jsUrl
    script.onerror = (res) => {
      reportScriptLoadError(option).then(res => {
        $track({ sceneType: 'QRCode', eventType: 'error_report_script_error', message: JSON.stringify(res) })
      })
      reject()
    }
    document.body.appendChild(script)
    return jsUrl
  })
}

export const qrcodeValid = async(callback, scene, phoneCode = '', phoneNumber = '', useLoading = true) => {
  const language = store.getters.language
  // 验证码国际化
  const lang = {
    'zh-CN': 'zh_CN',
    'zh-HK': 'zh_HK',
    'en': 'en_US',
    'ja-JP': 'en_US',
    'ko-KR': 'en_US',
    'th-TH': 'en_US',
    'vi-VN': 'en_US',
    'id-ID': 'en_US'
  }
  let env = ''
  // 生产环境 测试环境
  if (window._global.ENV === 'PRD') {
    if (window._global.CURRENT_SITE === 'CN') {
      env = 'prd-sfyun'
    } else if (window._global.CURRENT_SITE !== 'CN') {
      env = 'prd-gcp'
    }
  } else {
    // 测试环境
    if (window._global.CURRENT_SITE === 'CN') {
      if (window.location.host.indexOf('ibu-icas-w.sit.sf-express.com') !== -1) {
        env = 'sit'
      } else {
        env = 'sit'
      }
    } else if (window._global.CURRENT_SITE !== 'CN') {
      env = 'gcp' // sg测试环境
    }
  }
  const config = {
    'sysCode': isOS() ? 'IBU-ICAS-CORE-OS' : 'IBU-ICAS-CORE',
    'client': 'web-pc',
    'scene': scene,
    'lang': lang[language],
    'env': env,
    'phoneCode': phoneCode,
    'phoneNumber': phoneNumber,
    'useLoading': useLoading
  }
  console.log('env', window._global.ENV, window._global.CURRENT_SITE, lang[language], config)
  // sit | gcp | prd-sfyun | prd-gcp
  try {
    const icaptcha = new window.ICaptcha(config)
    const res = await icaptcha.verify().catch(err => {
      console.log('验证码 err', err)
      $track({ sceneType: 'QRCode', eventType: 'error_verify', message: phoneNumber + ':' + JSON.stringify(err) })
      return err
    })
    console.log('验证码 success:true', res)
    callback({ 'success': true, 'result': res })
    return { 'success': true, 'result': res }
  } catch (error) {
    console.log('验证码 success:false', error)
    callback({ 'success': false, 'result': error })
    return { 'success': false, 'result': error }
  }
}

export const captchaMiddleHandler = ({ res, initFuns, failFuns }) => {
  console.log('验证码res', res)
  if (res.success === true) { // 验证成功,显示腾讯滑块验证码
    initFuns && initFuns(res)
  } else { // 验证失败
    failFuns && failFuns(res)
    return
  }
}
